import {IGlobalSettingsModel} from '@/modules/settings/global/IGlobalSettingsModel';
import Vue from 'vue';
import {IGlobalConfigs} from '@/setup/GlobalConfigs/IGlobalConfigs';

class GlobalConfigs implements IGlobalSettingsModel {
  public id: number = 1;
  public name: string = '';
  public phone: string = '';
  public address: string = '';
  public iva: string = '';
  public language: string = '';
  public logo: string = '';
  public currency: string = '';
  public ready: boolean = false;
  // tslint:disable-next-line:variable-name
  public price_domicile_service: number | string = 0;
  // tslint:disable-next-line:variable-name
  public new_request_sound: boolean = false;
  // tslint:disable-next-line:variable-name
  public group_by_orders: boolean = false;
  // tslint:disable-next-line:variable-name
  public show_combined_aggregated_categories: boolean | null = null;
  // tslint:disable-next-line:variable-name
  public min_clients: number = 0;
  // tslint:disable-next-line:variable-name
  public max_clients: number = 0;
  // tslint:disable-next-line:variable-name
  public use_touch_keyboard: boolean = true;

  public units: Array<Record<'name' | 'type' | 'id', string>> = [];

  // tslint:disable-next-line:variable-name
  public show_category_name: boolean = false;

  // tslint:disable-next-line:variable-name
  public select_employee_before_order: boolean = false;
  // tslint:disable-next-line:variable-name

  public stock: string = '';
  // tslint:disable-next-line:variable-name
  public use_payment_terminal: boolean = false;

  // tslint:disable-next-line:variable-name
  public use_modifiers: boolean = false;
  // tslint:disable-next-line:variable-name
  public use_cashmatic: boolean = false;
  // tslint:disable-next-line:variable-name
  public allow_order_time_delay: boolean = false;
  // tslint:disable-next-line:variable-name
  public ticket_close_command: boolean = false;
  // tslint:disable-next-line:variable-name
  public close_barra_order_auto: boolean = true;
  
  public timezone: string = '';
  public request_without_client_domicile: boolean = false;
  public request_without_client_pickup: boolean = false;

  public street: string = '';
  public street_number: string = '';
  public city: string = '';
  public state: string = '';
  public postal_code: string = '';
  public reference: string = '';
  public latitude: number | string | null = null;
  public longitude: number | string | null = null;
}

export default Vue.observable(new GlobalConfigs() as IGlobalConfigs);
